module.exports = __webpack_public_path__ + "public/adminIcons/last24hrslistings.svg?5882103e";